import { Modal, Button } from "flowbite-react";
import { HiOutlineExclamationCircle } from "react-icons/hi";

const SessionExpiredModal = ({ open, onOk }) => {
  return (
    <Modal
      show={open}
      size="md"
      popup
      dismissible={false}
      theme={{
        root: {
          base: "fixed inset-0 z-[2000] h-full w-full overflow-y-auto overflow-x-hidden md:inset-0 md:h-full",
        },
        content: {
          inner:
            "relative rounded-lg bg-white shadow dark:bg-gray-700 flex flex-col max-h-full",
        },
        // The backdrop needs a high z-index too
        backdrop: "fixed inset-0 z-[1990] bg-gray-900/50 dark:bg-gray-900/80",
      }}
    >
      <Modal.Header />
      <Modal.Body>
        <div className="text-center">
          <HiOutlineExclamationCircle className="mx-auto mb-4 h-14 w-14 text-gray-400" />
          <h3 className="mb-5 text-lg font-normal text-gray-500">
            Session expired
          </h3>

          <Button color="failure" onClick={onOk}>
            OK
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default SessionExpiredModal;
